import { replaceStrValues } from 'platform/shared/health-apps';
import {
  transformDate,
  checkIfEndDateAfterStartDate,
  isSsnDuplicated,
} from '../utils/helpers';
import content from '../utils/content.json';

export const validations = {
  isAfterMarriageStartDate: (errors, values, formData) => {
    if (
      formData?.marriageToVeteranStartDate &&
      !checkIfEndDateAfterStartDate(values, formData.marriageToVeteranStartDate)
    ) {
      errors.addError(
        replaceStrValues(
          content['validation-end-after-start-date'],
          transformDate(formData.marriageToVeteranStartDate),
        ),
      );
    }
  },
  isAfterPreviousMarriageStartDate: (errors, values, formData) => {
    if (
      formData?.dateOfMarriage &&
      !checkIfEndDateAfterStartDate(values, formData.dateOfMarriage)
    ) {
      errors.addError(
        replaceStrValues(
          content['validation-end-after-start-date'],
          transformDate(formData.dateOfMarriage),
        ),
      );
    }
  },
  isAfterSeparationStartDate: (errors, values, formData) => {
    if (
      formData?.separationStartDate &&
      !checkIfEndDateAfterStartDate(values, formData.separationStartDate)
    ) {
      errors.addError(
        replaceStrValues(
          content['validation-end-after-start-date'],
          transformDate(formData.separationStartDate),
        ),
      );
    }
  },
  isAfterVeteranBirthDate: (errors, values, formData) => {
    if (
      formData?.veteranDateOfBirth &&
      !checkIfEndDateAfterStartDate(values, formData.veteranDateOfBirth)
    ) {
      errors.addError(
        replaceStrValues(
          content['validation-death-after-birth-date'],
          transformDate(formData.veteranDateOfBirth),
        ),
      );
    }
  },
  isAfterTreatmentStartDate: (errors, values, formData) => {
    if (
      formData?.startDate &&
      !checkIfEndDateAfterStartDate(values, formData.startDate)
    ) {
      errors.addError(
        replaceStrValues(
          content['validation-end-after-start-date'],
          transformDate(formData.startDate),
        ),
      );
    }
  },
  isBeforeVeteranDeathDate: (errors, values, formData) => {
    if (
      formData?.veteranDateOfDeath &&
      !checkIfEndDateAfterStartDate(formData.veteranDateOfDeath, values)
    ) {
      errors.addError(content['validation-before-veteran-death-date']);
    }
  },
  isSsnDuplicated: (errors, values, formData) => {
    if (isSsnDuplicated(values, formData)) {
      errors.addError(content['validation-duplicate-ssn']);
    }
  },
};
